<template>
  <div class="datatable">
    <table :class="table_class">
      <tbody>
        <tr v-for="(col, index) in columns" :key="index">
          <td :class="name_class">{{ $t(col.name) }}</td>
          <td>
            <div :child_class="child_class">
              <slot :name="col.id">{{ $t(col.name) }}</slot>
            </div>
          </td>
        </tr>
        <tr>
          <slot name="tfooter"></slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
/* Comment */
</style>

<script>
export default {
  name: 'VerticalTable',
  props: {
    columns: {
      type: Array,
      default: null
    },
    table_class: {
      type: String,
      default: ''
    },
    name_class: {
      type: String,
      default: ''
    },
    child_class: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// VerticalTable.vue?577ad6c6